import jQuery from 'jquery';
import SimpleBar from "simplebar";
import $ from "jquery";

(function ($) {
    $(document).ready(function () {
        var num1Scrolled = false,
            num2Scrolled = false;

        let num1 = $('#years-of-experience'),
            num2 = $('#insurances-number');

        $(window).scroll(function(){
            if (num1.length > 0 && isElementInViewport(num1) && num1Scrolled === false) {
                num1Scrolled = true;
                animateValue(num1, 0, parseInt(num1.data('counting-number')), 1500, 1);
            }
            if (num2.length > 0 && isElementInViewport(num2) && num2Scrolled === false) {
                num2Scrolled = true;
                animateValue(num2, 0, parseInt(num2.data('counting-number')), 1500, 1000);
            }
        }).scroll();

        collapseItems();
        faqHeaderAccordion();
        initSimpleBar($('.search-results__rows'));

        workflowBoxes();
        jsOpenMenu();
    });

    function workflowBoxes() {
        initWorkflowBoxes();

        $(window).resize(function () {
            initWorkflowBoxes();
        });
    }

    function initWorkflowBoxes() {
        let width = window.innerWidth,
            fixedHeight = width > 767;

        calculateWorkflowBoxesHeight(fixedHeight);
    }

    function calculateWorkflowBoxesHeight(fixedHeight) {
        let steps = $('.work-process-step--line'),
            maxHeight = 0;

        steps.each(function () {
            $(this).height('');
        });

        steps.each(function () {
            if ($(this).height() > maxHeight) {
                maxHeight = $(this).height();
            }
        });

        steps.each(function () {
            if(fixedHeight) {
                $(this).height(maxHeight)
            }
            else {
                $(this).height('');
            }
        });
    }


    function initSimpleBar(container) {
        if(container.length > 0) {
            container.each(function() {
                new SimpleBar($(this)[0], {autoHide: false});
            });
        }
    }

    function collapseItems() {
        $('.collapse-header').on('click', function () {
            let parent = $(this).closest('.collapse-item');
            if (parent.hasClass('collapse-item--active')) {
                parent.removeClass('collapse-item--active');
            } else {
                parent.addClass('collapse-item--active');
            }
        });
    }

    function faqHeaderAccordion() {
        $('.faq-section__title').on('click', function() {
            const parent = $(this).closest('.faq-section');
            const faq = parent.find('.faq');
            const faqTitleHeight = $(this).height();

            if ( parent.hasClass('open-accordion') ) {
                parent.animate({
                    height: `${faqTitleHeight}px`
                }, 400, function() {
                    faq.css("position", "absolute");
                    parent.removeAttr( 'style' ).removeClass('open-accordion');
                })
            } else {
                const faqAnswerHeight = faq.height() + parseInt(faq.css('marginBottom'));
                const faqSectionHeight = `${faqTitleHeight + faqAnswerHeight}px`;

                parent.animate({
                    height: faqSectionHeight
                }, 400, function() {
                    faq.css("position", "static");
                    parent.removeAttr( 'style' ).addClass('open-accordion');
                })
            }
        })
    }

    function jsOpenMenu() {
        if( window.innerWidth > 1024 ) {
            $('.button.js-open-menu').on('click', function (e) {
                e.preventDefault();
                let activeMenu = $('.menu-item.js-open-menu');
                if(activeMenu.hasClass('active')) {
                    activeMenu.removeClass('active')
                } else {
                    activeMenu.addClass('active')
                }
                $('.primary-nav__submenu-container').mouseover(function () {
                    activeMenu.removeClass('active')
                })
            })
        }
    }

    function animateValue(obj, start, end, duration, increment) {
        if (start === end) return;
        let range = (end - start) / increment,
            current = start,

            stepTime = duration / range,
            timer = setInterval(function () {
                current += increment;
                obj.html(current.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' '));
                if (current === end) {
                    clearInterval(timer);
                }
            }, stepTime);
    }

    function isElementInViewport(el) {
        if (typeof jQuery === "function" && el instanceof jQuery) {
            el = el[0];
        }

        var rect = el.getBoundingClientRect();

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }


})(jQuery);
